import React, { useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import RoutingMachine from "./RoutingMachine";

import icon from 'leaflet/dist/images/marker-icon.png';
import iconnShadow from 'leaflet/dist/images/marker-shadow.png';

const greenIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const orangeIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const redIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});



let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconnShadow,
    iconAnchor: [12, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;


const InteractiveMarker = ({ poi, icon, isActive, label }) => {
    const markerRef = useRef(null);
    const map = useMap();

    useEffect(() => {
        if (isActive && markerRef.current) {
            markerRef.current.openPopup();

            map.flyTo(poi.position, 14, {
                animate: true,
                duration: 1.5
            });
        }
    }, [isActive, map, poi.position]);

    return (
        <Marker
            ref={markerRef}
            position={poi.position}
            icon={icon}
        >
            <Popup>
                <strong>{poi.name}</strong>
                <br />
                <small>{label}</small>
                <br />
                {poi.description}
            </Popup>
        </Marker>
    );
};


const LeafletMapContainer = ({ pois, activePoiId }) => {

    const getMarkerIcon = (index) => {
        if (index === 0) return greenIcon;
        if (index === pois.length - 1) return redIcon;
        return orangeIcon;
    }

    const getLabel = (index) => {
        if (index === 0) return "Start";
        if (index === pois.length - 1) return "Destination";
        return `Stop ${index}`;
    }

    const defaultCenter = [52.237, 21.017];
    const center = pois.length > 0 ? pois[0].position : defaultCenter;

    return (
        <MapContainer center={center} zoom={6} style={{ height: '100%', width: '100%' }}>
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {pois.map((poi, index) => (
                <InteractiveMarker
                    key={poi.id}
                    poi={poi}
                    icon={getMarkerIcon(index)}
                    label={getLabel(index)}
                    isActive={activePoiId === poi.id}
                />
            ))}

            {pois.length >= 2 && <RoutingMachine points={pois} />}

        </MapContainer>
    );
};

export default LeafletMapContainer;
